document.addEventListener("DOMContentLoaded", function() {
    const categoryLinks = document.querySelectorAll(".categoryGamesMenu a");
    const gameListWrapper = document.getElementById("gameList-wrapper");
  
    const loadMoreLink = document.getElementById("loadMoreLink");
    let currentCategory = "All Games";
    let displayedGames = 8;
    let totalCategoryGames = 0;
  
    function displayGamesByCategory(categoryName) {
      const allGames = gameListWrapper.querySelectorAll(".gameSingle");
      allGames.forEach(game => {
        game.style.display = "none";
      });
  
      const selectedCategoryGames = gameListWrapper.querySelectorAll(`.category-games[data-category-name="${categoryName}"] .gameSingle`);
      totalCategoryGames = selectedCategoryGames.length;
  
      for (let i = 0; i < Math.min(8, totalCategoryGames); i++) {
        selectedCategoryGames[i].style.display = "inline-block";
      }
  
      categoryLinks.forEach(categoryLink => {
        categoryLink.classList.remove("active");
        if (categoryLink.getAttribute("data-category-name") === categoryName) {
          categoryLink.classList.add("active");
        }
      });
  
      currentCategory = categoryName;
      displayedGames = Math.min(8, totalCategoryGames);
      updateLoadMoreVisibility();
    }
  
    function updateLoadMoreVisibility() {
      if (displayedGames >= totalCategoryGames) {
        loadMoreLink.style.display = "none";
      } else {
        loadMoreLink.style.display = "inline-block";
        }
    }
  
    categoryLinks.forEach(categoryLink => {
      categoryLink.addEventListener("click", function(event) {
        event.preventDefault();
        const categoryName = this.getAttribute("data-category-name");
        displayGamesByCategory(categoryName);
      });
    });
  
    loadMoreLink.addEventListener("click", function(event) {
      event.preventDefault();
      const gamesToDisplay = gameListWrapper.querySelectorAll(`.category-games[data-category-name="${currentCategory}"] .gameSingle`);
      for (let i = displayedGames; i < displayedGames + 8; i++) {
        if (gamesToDisplay[i]) {
          gamesToDisplay[i].style.display = "inline-block";
        }
      }
      displayedGames += 8;
      updateLoadMoreVisibility();
    });
  
    displayGamesByCategory("All Games");
  });
  